import {GoDotFill} from "react-icons/go";
import useTranslate from "../../modules/local/useTranslate";
import classNames from "classnames";
import React from "react";

export const ItemInfoWithIcon = ({
                                     icon = <GoDotFill size={10} className="text-color-500"/>,
                                     value,
                                     className = 'text-base italic',
                                     primary = false,
                                 }) => {
    const t = useTranslate()
    return !!value && (
        <div className={classNames('space-x-1', className)}>
            {icon}
            <span className={primary === true ? 'font-bold text-gray-800' : value ? 'font-semibold text-color-100' : 'text-color-300 italic'}>
              {value ? value : t('not update')}
          </span>
        </div>
    )
}
